import { useState, useEffect } from "react";
import { connect } from "react-redux";
import Table from "./Table";
import Options from "./Options";
import moment from "moment";
import { Box, Button, useTheme } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import _, { result } from "lodash";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

import resultsService from "../../../Services/resultsService";
function CardioR(props) {
  const theme = useTheme();
  const [currentPage, setCurrentPage] = useState(1);
  const [filterProps, setFilterProps] = useState({});
  const [hasFile, setHasFile] = useState(false);

  useEffect(() => {
    if (props.selectedPatient?.custid) {
      resultsService
        .checkSummaryReport(props.selectedPatient?.custid)
        .then((r) => setHasFile(r.data));
    }
  }, [props.selectedPatient]);

  const printReport = async () => {
    return await resultsService
      .getSummaryReport(props.selectedPatient?.custid)
      .then((p) => {
        return `data:application/pdf;base64,${p.data}`;
      });
  };

  const printCoverPaper = async () => {
    return await resultsService
      .getCoverPaper(props.selectedPatient?.custid)
      .then((p) => {
        return `data:application/pdf;base64,${p.data}`;
      });
  };
  const downloadPDF = async () => {
    const linkSource = await printReport();
    const downloadLink = document.createElement("a");

    downloadLink.href = linkSource;
    downloadLink.download = "cardioR_summaryREport.pdf";
    downloadLink.click();
  };
  const downloadCoverPaperPDF = async () => {
    const linkSource = await printCoverPaper();
    const downloadLink = document.createElement("a");

    downloadLink.href = linkSource;
    downloadLink.download = "cardioR_CoverPaper.pdf";
    downloadLink.click();
  };
  const resultList = props.selectedPatient
    ? props.cardioRResults
        ?.filter((a) => a.custid == props.selectedPatient.custid)
        ?.sort((b, a) => a.devdatetime - b.devdatetime)
    : props.cardioRResults?.sort((b, a) => a.devdatetime - b.devdatetime);
  const pages = Math.ceil(resultList?.length / 10);

  const toShow = resultList?.slice(
    (currentPage - 1) * 10,
    (currentPage - 1) * 10 + 10,
  );

  return (
    <div>
      <h2>דוחות Cardio-R</h2>
      <h3 style={{ display: resultList?.length > 0 && "none" }}>אין נתונים</h3>
      {props.selectedPatient ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // במובייל נשארים אחד מעל השני לנוחות
            justifyContent: "flex-start", // מצמיד אותם לצד ימין (בתחילת השורה ב-RTL)
            alignItems: "center",
            gap: 2,
            mb: 3,
          }}
          className="printerHide"
        >
          <Button
            variant="contained"
            color="primary"
            startIcon={<PrintIcon sx={{ ml: 1, mr: 0 }} />}
            onClick={async () => {
              await downloadPDF();
            }}
            sx={{
              borderRadius: "12px",
              height: "56px",
              px: 4,
              fontWeight: 700,
              width: { xs: "100%", md: "auto" }, // בטלפון יהיה רחב, במחשב רק לפי גודל הטקסט
              boxShadow: `0 4px 12px ${theme.palette.primary.main}33`,
              whiteSpace: "nowrap", // מונע מהטקסט לרדת שורה בתוך הכפתור
            }}
          >
            להורדת דוח סיכום
          </Button>

          <Button
            variant="contained"
            color="secondary"
            startIcon={<PrintIcon sx={{ ml: 1, mr: 0 }} />}
            onClick={async () => {
              await downloadCoverPaperPDF();
            }}
            sx={{
              borderRadius: "12px",
              height: "56px",
              px: 4,
              fontWeight: 700,
              width: { xs: "100%", md: "auto" }, // כנ"ל - רספונסיביות חכמה
              boxShadow: `0 4px 12px ${theme.palette.secondary.main}33`,
              whiteSpace: "nowrap",
            }}
          >
            להורדת דוח התפלגויות
          </Button>
        </Box>
      ) : (
        <div>
          <Link
            to={`../patients`}
            style={{
              color: "navy",
              borderBottom: "2px solid navy",
              fontWeight: "bolder",
            }}
          >
            {">"} בחירת לקוח
          </Link>
        </div>
      )}
      <br />
      <br />
      <Table
        kind="cardioR"
        measurment={toShow}
        pages={pages}
        currentPage={currentPage}
        updatePageNumber={(i) => setCurrentPage(i)}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    cardioRResults: state.cardioRResults,
    selectedPatient: state.selectedPatient,
  };
};
export default connect(mapStateToProps)(CardioR);
